<div class="border-bottom-1 font-bold mb-2">
    <label>Select GAP output(s)</label>
</div>
<app-listbox [disabled]="!isProjectOwnershipValid" [filter]="false" [showToggleAll]="false" [multiple]="true" [checkbox]="true" [options]="gapOutputs" [optionLabel]="'label'" [model]="selectedOutputs" [style]="{'width':'100%'}" (onChangeEvent)="onOutputSelectionChanged($event)"></app-listbox>